import React, { useState } from 'react';
import { Card, Col, Row, Select, Space, Table, Tag, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { epcService } from '@/services/epc.service';

const { Text } = Typography;

type Props = { projectId?: string };

export const ProgressPanel: React.FC<Props> = ({ projectId }) => {
  const [mode, setMode] = useState('weighted');

  const progressQ = useQuery({
    queryKey: ['cep-progress', projectId, mode],
    queryFn: () => epcService.getCepProgress(projectId, mode),
    enabled: !!projectId,
    staleTime: 15_000,
  });

  if (!projectId) return <Tag>Select a project for progress roll-up</Tag>;

  const data = (progressQ.data || {}) as any;

  return (
    <div>
      <Space style={{ marginBottom: 12 }} wrap>
        <Tag color="geekblue">CEP Wave 2 Progress Engine</Tag>
        <Select
          style={{ width: 180 }}
          value={mode}
          onChange={setMode}
          options={[
            { value: 'weighted', label: 'Weighted / Earned' },
            { value: 'package', label: 'Package average' },
            { value: 'quantity', label: 'Quantity / Physical' },
            { value: 'milestone', label: 'Milestone-based' },
          ]}
        />
      </Space>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col xs={12} md={8}>
          <Card size="small">
            Project % <Text strong>{String(data.project_progress_pct ?? '—')}</Text>
          </Card>
        </Col>
        <Col xs={12} md={8}>
          <Card size="small">
            Packages <Text strong>{String(data.package_count ?? 0)}</Text>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card size="small">
            <Text type="secondary">{String(data.note || '')}</Text>
          </Card>
        </Col>
      </Row>
      <Table
        size="small"
        title={() => 'By discipline'}
        pagination={false}
        rowKey={(r) => String(r.key)}
        loading={progressQ.isLoading}
        dataSource={(data.by_discipline as any[]) || []}
        columns={[
          { title: 'Discipline', dataIndex: 'title' },
          { title: 'Packages', dataIndex: 'package_count', width: 100 },
          { title: 'Progress %', dataIndex: 'progress_pct', width: 110 },
        ]}
        style={{ marginBottom: 16 }}
      />
      <Table
        size="small"
        title={() => 'By area'}
        pagination={false}
        rowKey={(r) => String(r.key)}
        loading={progressQ.isLoading}
        dataSource={(data.by_area as any[]) || []}
        columns={[
          { title: 'Area', dataIndex: 'title' },
          { title: 'Code', dataIndex: 'code', width: 100 },
          { title: 'Packages', dataIndex: 'package_count', width: 100 },
          { title: 'Progress %', dataIndex: 'progress_pct', width: 110 },
        ]}
      />
    </div>
  );
};

export default ProgressPanel;
